import React from 'react';
import { CHECKOUT_URL } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`block w-full text-center cursor-pointer px-4 py-3.5 sm:py-4 font-heading font-bold text-sm sm:text-lg uppercase tracking-wide rounded-lg bg-cta text-white hover:bg-cta-dark hover:scale-[1.02] transition-all duration-200 border-b-4 border-[#A85510] active:border-b-0 active:translate-y-1 shadow-[0_4px_14px_0_rgba(230,126,34,0.4)] ${className}`} data-id="element-29" data-mp="2kyy3khavig8y">
      {children}
    </a>;
}